import { useAuth0 } from '@auth0/auth0-react';

// Custom hook to get user account and token similar to MSAL's useMsal
export const useAuth0Account = () => {
    const { user, getAccessTokenSilently, isAuthenticated } = useAuth0();
    
    const getAccessToken = async (request = {}) => {
        try {
            const token = await getAccessTokenSilently({
                authorizationParams: {
                    audience: process.env.REACT_APP_AUTH0_AUDIENCE,
                    scope: request.scopes ? request.scopes.join(' ') : 'read:current_user',
                    ...request.authorizationParams
                }
            });
            return { accessToken: token };
        } catch (error) {
            console.error('Error getting access token:', error);
            return null;
        }
    };

    return {
        user: user ? {
            username: user.email,
            name: user.name,
            ...user
        } : null,
        getAccessToken,
        isAuthenticated
    };
};